export const NAMESPACE = 'bulkImportInvoices'
